const doc = [({"da":({"js":({"admin":({"layout":({"top_menu":({"extended_search":({"group":({"rule":({"rule":"Regel", "enter_value":"Indtast værdi"})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;